import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    id: '',
    openedTab: ['welcome'],
    activeTab: 'welcome',
    show: false,
    pageAreaId_x: localStorage.getItem('AreaId') || '',
    
    // detailPageData:{},//服务详情页的数据信息

    puUrl_x: '',

    areaArrs_x: JSON.parse(localStorage.getItem('fixed_areaArrs')) || {
      province: [],
      city: [],
      county: [],
      town: [],
      village: [],
    },
    areaNames_x: JSON.parse(localStorage.getItem('fixed_areaNames')) || [],
    areaIds_x: JSON.parse(localStorage.getItem('fixed_areaIds')) || [],
    dis_x: JSON.parse(localStorage.getItem('fixed_dis')) || [],

    siteNavs_x: [],
    defaultLogo_x: require('@/assets/logo.png'),
  },
  getters:{
    show: (state) => {
      return state.show
    },
  },
  mutations: {
    logout(state, data){
      state.areaArrs_x = {}
      state.areaNames_x = []
      state.areaIds_x = []
      state.dis_x = []
      localStorage.removeItem('loginData')
      localStorage.removeItem('fixed_areaArrs')
      localStorage.removeItem('fixed_areaNames')
      localStorage.removeItem('fixed_areaIds')
      localStorage.removeItem('fixed_dis')
    },
    changeOpenedTab(state, data){
      state.openedTab = [data]
    },
    addTab (state, data) {
      state.openedTab.push(data)
      console.log(`%cstate.openedTab:`, 'color: #f00;', state.openedTab)
    },
    changeTab (state, data) {
      state.activeTab = data
    },
    deductTab (state, data) {
      let index = state.openedTab.indexOf(data)
      state.openedTab.splice(index, 1)
    },
    setShow(state, bool) {
      state.show = bool
    },
    setPageAreaId(state, data){
      state.pageAreaId_x = data
      localStorage.setItem('AreaId', data)
    },
    // goDetailPage(state, data) {
    //   state.detailPageData = data
    // },
    puUrl_x_save(state, data){
      state.puUrl_x = data
      // console.log(`%cxxxxx:`, 'color: #0f0;', state.puUrl_x)
    },
    fixedArea_save(state, data){
      state.areaArrs_x = data.areaArrs
      state.areaNames_x = data.areaNames
      state.areaIds_x = data.areaIds
      state.dis_x = data.dis
      localStorage.setItem('fixed_areaArrs', JSON.stringify(data.areaArrs))
      localStorage.setItem('fixed_areaNames', JSON.stringify(data.areaNames))
      localStorage.setItem('fixed_areaIds', JSON.stringify(data.areaIds))
      localStorage.setItem('fixed_dis', JSON.stringify(data.dis))
    },
    siteNavs_save(state, data) {
      state.siteNavs_x = data
    },
    defaultLogo_save(state, data) {
      state.defaultLogo_x = data
    },
  },
  actions:{
    getShow(context,bool){
      context.commit('setShow',bool)
    }
  }
})